import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';
import { SessionService } from '../services/session.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  
  constructor(private router: Router,
              private sessionSvc: SessionService){}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    
    const authInfo = this.sessionSvc.getUserValue();
    const workspace = this.sessionSvc.getUserWorkspace();
    
    // Check if user is authenticated
    if(!authInfo || !authInfo.user || !authInfo.user.name) {
      this.router.navigate(['/auth/login'], { queryParams: {returnUrl: state.url}});
      return false;
    }

    // Check if workspace is set
    if(!workspace || !workspace.uid) {
      // If user has workspaces but none is selected, redirect to workspace selection
      if(authInfo.user.workspaces && authInfo.user.workspaces.length > 0) {
        this.router.navigate(['/workspace-selection'], { queryParams: {returnUrl: state.url}});
        return false;
      } else {
        // User has no workspaces, redirect to appropriate page
        this.router.navigate(['/no-workspace']);
        return false;
      }
    }

    return true;
  }
  
}
